(function () {
  'use strict';

  var COUNTER_DURATION = 1600;

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function parseStatValue(text) {
    var match = text.match(/^([^0-9]*)(\d+\.?\d*)(.*)$/);
    if (!match) return null;
    return { prefix: match[1], number: parseFloat(match[2]), suffix: match[3] };
  }

  function formatNumber(n, isDecimal) {
    if (isDecimal) return n.toFixed(1);
    return Math.round(n).toString();
  }

  function animateCounter(el) {
    var parsed = parseStatValue(el.textContent.trim());
    if (!parsed) return;
    var isDecimal = parsed.number !== Math.floor(parsed.number);
    var start = null;

    function step(ts) {
      if (!start) start = ts;
      var elapsed = ts - start;
      var progress = Math.min(elapsed / COUNTER_DURATION, 1);
      var value = easeOutCubic(progress) * parsed.number;
      el.textContent = parsed.prefix + formatNumber(value, isDecimal) + parsed.suffix;
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  function initCounters(section) {
    if (section._countersInit) return;
    section._countersInit = true;
    section.querySelectorAll('.nb-about-results__card-value').forEach(animateCounter);
  }

  function init() {
    document.querySelectorAll('.nb-about-results').forEach(function (section) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            initCounters(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
